import React, { Component } from "react";

import { message, Space, Button } from 'antd';
import WidgetModal from "./../../widget/WidgetModal";
import WidgetTable from "./../../widget/WidgetTable";
import WidgetAjax from "../../widget/WidgetAjax";
import Config from "../../config/Config";
import './../../css/frame.css';
import './../../css/project.css';
import './index.scss';
import './index.css';

class Index extends Component {

    constructor(props) {
        super(props);

        this.state = {
            columns: [
                { name: 'TASKNAME', title: '申报任务', type: 'string', description: '申报任务', properties: { width: 220 } },
                { name: 'creating_time', title: '申报时间', type: 'string', description: '申报时间', },
                {
                    name: 'HJMCNODE', title: '申报状态', type: 'string', description: '申报状态', properties: {
                        render: (completed, record) => {
                            return (
                                <div className="sd-start">
                                    <span>
                                        {/* <span className="sg-table-color sg-table-color4" style={{ display: record.HJMC === '县审核' ? 'inline-block' : 'none' }}>{record.HJMC === '县审核' ? '待审核' : ''}</span>
                                        <span className="sg-table-color sg-table-color4" style={{ display: record.HJMC === '县报送' ? 'inline-block' : 'none' }}>{record.HJMC === '县报送' ? '待审核' : ''}</span>
                                        <span className="sg-table-color sg-table-color4" style={{ display: record.HJMC === '县审核驳回' ? 'inline-block' : 'none' }}>{record.HJMC === '县审核驳回' ? '驳回' : ''}</span>
                                        <span className="sg-table-color sg-table-color4" style={{ display: record.HJMC === '县审核退回' ? 'inline-block' : 'none' }}>{record.HJMC === '县审核退回' ? '退回' : ''}</span>
                                        <span className="sg-table-color sg-table-color4" style={{ display: record.HJMC === '市报送' ? 'inline-block' : 'none' }}>{record.HJMC === '市报送' ? '待审核' : ''}</span>
                                        <span className="sg-table-color sg-table-color3" style={{ display: record.HJMC === '市报送退回' ? 'inline-block' : 'none' }}>{record.HJMC === '市报送退回' ? '退回' : ''}</span>
                                        <span className="sg-table-color sg-table-color1" style={{ display: record.HJMC === '市报送驳回' ? 'inline-block' : 'none' }}>{record.HJMC === '市报送驳回' ? '驳回' : ''}</span>
                                        <span className="sg-table-color sg-table-color1" style={{ display: record.HJMC === '市审核退回' ? 'inline-block' : 'none' }}>{record.HJMC === '市审核退回' ? '退回' : ''}</span>
                                        <span className="sg-table-color sg-table-color4" style={{ display: record.HJMC === '市审核' ? 'inline-block' : 'none' }}>{record.HJMC === '市审核' ? '待审核' : ''}</span>
                                        <span className="sg-table-color sg-table-color1" style={{ display: record.HJMC === '市审核驳回' ? 'inline-block' : 'none' }}>{record.HJMC === '市审核驳回' ? '驳回' : ''}</span>
                                        <span className="sg-table-color sg-table-color4" style={{ display: record.HJMC === '省审核' ? 'inline-block' : 'none' }}>{record.HJMC === '省审核' ? '待审核' : ''}</span>
                                        <span className="sg-table-color sg-table-color1" style={{ display: record.HJMC === '省报送驳回' ? 'inline-block' : 'none' }}>{record.HJMC === '省报送驳回' ? '驳回' : ''}</span>
                                        <span className="sg-table-color sg-table-color1" style={{ display: record.HJMC === '省审核驳回' ? 'inline-block' : 'none' }}>{record.HJMC === '省审核驳回' ? '驳回' : ''}</span>
                                        <span className="sg-table-color sg-table-color4" style={{ display: record.HJMC === '总局' ? 'inline-block' : 'none' }}>{record.HJMC === '总局' ? '认定入库' : ''}</span>
                                        <span className="sg-table-color sg-table-color2" style={{ display: !['总局', '市审核退回', '市审核驳回', '省报送驳回', '省审核', '市审核', '市报送驳回', '市报送退回', '市报送', '县报送', '县审核', '县审核退回', '县审核驳回', '省审核驳回'].includes(record.HJMC) ? 'inline-block' : 'none' }}>{!['总局', '省报送驳回', '市审核', '省审核', '市报送驳回', '市报送退回', '市报送', '县报送', '县审核'].includes(record.HJMC) ? record.HJMC : ''}</span> */}
                                        <span className="sg-table-color sg-table-color4" style={{ display: record.HJMC === '县审核' ? 'inline-block' : 'none' }}>{record.HJMC === '县审核' ? '待审核' : ''}</span>
                                        <span className="sg-table-color sg-table-color4" style={{ display: record.HJMC === '县报送' ? 'inline-block' : 'none' }}>{record.HJMC === '县报送' ? '待审核' : ''}</span>
                                        <span className="sg-table-color sg-table-color4" style={{ display: record.HJMC === '县审核驳回' ? 'inline-block' : 'none' }}>{record.HJMC === '县审核驳回' ? '驳回' : ''}</span>
                                        <span className="sg-table-color sg-table-color4" style={{ display: record.HJMC === '县审核退回' ? 'inline-block' : 'none' }}>{record.HJMC === '县审核退回' ? '退回' : ''}</span>
                                        <span className="sg-table-color sg-table-color4" style={{ display: record.HJMC === '市报送' ? 'inline-block' : 'none' }}>{record.HJMC === '市报送' ? '待审核' : ''}</span>
                                        <span className="sg-table-color sg-table-color3" style={{ display: record.HJMC === '市报送退回' ? 'inline-block' : 'none' }}>{record.HJMC === '市报送退回' ? '退回' : ''}</span>
                                        <span className="sg-table-color sg-table-color1" style={{ display: record.HJMC === '市报送驳回' ? 'inline-block' : 'none' }}>{record.HJMC === '市报送驳回' ? '驳回' : ''}</span>
                                        <span className="sg-table-color sg-table-color1" style={{ display: record.HJMC === '市审核退回' ? 'inline-block' : 'none' }}>{record.HJMC === '市审核退回' ? '退回' : ''}</span>
                                        <span className="sg-table-color sg-table-color4" style={{ display: record.HJMC === '市审核' ? 'inline-block' : 'none' }}>{record.HJMC === '市审核' ? '待审核' : ''}</span>
                                        <span className="sg-table-color sg-table-color1" style={{ display: record.HJMC === '市审核驳回' ? 'inline-block' : 'none' }}>{record.HJMC === '市审核驳回' ? '驳回' : ''}</span>
                                        <span className="sg-table-color sg-table-color4" style={{ display: record.HJMC === '省审核' ? 'inline-block' : 'none' }}>{record.HJMC === '省审核' ? '待审核' : ''}</span>
                                        <span className="sg-table-color sg-table-color1" style={{ display: record.HJMC === '省报送驳回' ? 'inline-block' : 'none' }}>{record.HJMC === '省报送驳回' ? '驳回' : ''}</span>
                                        <span className="sg-table-color sg-table-color1" style={{ display: record.HJMC === '省审核驳回' ? 'inline-block' : 'none' }}>{record.HJMC === '省审核驳回' ? '驳回' : ''}</span>
                                        <span className="sg-table-color sg-table-color4" style={{ display: record.HJMC === '总局' ? 'inline-block' : 'none' }}>{record.HJMC === '总局' ? '认定入库' : ''}</span>
                                        <span className="sg-table-color sg-table-color2" style={{ display: !['总局', '市审核退回', '市审核驳回', '省报送驳回', '省审核', '市审核', '市报送驳回', '市报送退回', '市报送', '县报送', '县审核', '县审核退回', '县审核驳回', '省审核驳回'].includes(record.HJMC) ? 'inline-block' : 'none' }}>{!['总局', '省报送驳回', '市审核', '省审核', '市报送驳回', '市报送退回', '市报送', '县报送', '县审核'].includes(record.HJMC) ? record.HJMC : ''}</span>
                                    </span>
                                </div>
                            );
                        },
                    }
                },
                // { name: 'REMARK', title: '备注', type: 'string', description: '备注', properties:{width:520}},
                {
                    name: "operation", title: "操作", type: "string", description: "操作", properties: {
                        render: (completed, record, index) => {
                            const STATE1 = [
                                { name: "查看详情", click: "viewDetail" },
                                { name: "修改资料", click: "editInfo", render: { condition: 'HJMC', value: ['草稿', '县审核退回', '市报送退回', '市审核退回', '省审核退回', '待审核'] } },
                                { name: "撤销", click: "withdraw", render: { condition: 'HJMC', value: ['草稿', '待审核', '县审核退回', '市报送退回', '市审核退回'] } },
                                { name: "申报通知", click: "goNotice" },
                            ]
                            const STATE0 = [
                                { name: "查看详情", click: "viewDetail" },
                                { name: "修改资料", click: "editInfo", render: { condition: 'HJMC', value: ['县审核退回', '市报送退回', '省审核退回', '市审核退回'] } },
                                { name: "撤销", click: "withdraw", render: { condition: 'HJMC', value: ['草稿', '待审核', '县审核退回', '市报送退回', '市审核退回'] } },
                                { name: "申报通知", click: "goNotice" },
                            ]

                            return record.STATE === '0' ?
                                <Space size="middle">
                                    {
                                        STATE0.map((item) => {
                                            return <Button type="link" className="sg-tab-btn" disabled={item.disabled} key={index} onClick={() => { this.notify(item.click, record) }}>{item.name}</Button>
                                        })
                                    }
                                </Space >
                                : <Space size="middle">
                                    {
                                        STATE1.map((item) => {
                                            return <Button type="link" className="sg-tab-btn" disabled={item.disabled} key={index} onClick={() => { this.notify(item.click, record) }}>{item.name}</Button>
                                        })
                                    }
                                </Space >
                        }
                        // operations: [
                        //     {name: "查看详情", click: "viewDetail" },
                        //     {name: "修改资料", click: "editInfo", render: {condition: 'HJMC', value: ['草稿', '县审核退回', '市报送退回', '市审核退回', '省审核退回', '待审核'] } },
                        //     {name: "撤销", click: "withdraw", render: {condition: 'HJMC', value: ['草稿', '待审核', '县审核退回', '市报送退回', '市审核退回'] } },
                        //     {name: "申报通知", click: "goNotice" },
                        //     //    render:{condition:'HJMC',value:['草稿','待审核']}
                        // ]
                    },
                },
            ],
            data: [],
            total: 100,
            tableOptions: {
                records: 10,
                check: false
            },
            modal: null,
            modelOptions: {
                type: 'message',
                title: '提示',
                index: 0,
                label: 1,
                width: 300,
                message: <div className="sg-index-bg">
                    <div className="sd-middle">
                        {/* <img className='sg-bg-img1' alt='#' src={require('../../img/business/complete.png')} /> */}
                        <svg t="1688104158159" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3910" width="80" height="80"><path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64z m-32 232c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V296z m32 440c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48z" fill="#ff0000" p-id="3911"></path></svg>

                    </div>
                    <div className="sg-filling-layer">请谨慎操作！</div>
                    <div className="sg-filling-layer">一旦撤回将无法提交审核以及修改。</div>
                </div>,
                isNext: false,
                isOk: true,
                wrapClassName: 'sg-index-model',
                bodyStyle: { padding: 0 },
            },
            isHide: true,
            revokeInfo: {}
        }
        this.goInformation.bind(this)
        this.notify.bind(this)
        this.onOk = this.onOk.bind(this);
    }
    componentDidMount() {
        this.querySqHisList()
    }

    queryInfo(SSQXID) {
        let info =
            WidgetAjax.ajax({
                url: Config.getBasePath() + '/template/info',
                params: {
                    SSQXID: SSQXID
                },
                callback: (data) => {
                    if (data && data.status === 0) {

                    }
                }
            }, this);

    }
    querySqHisList() {
        WidgetAjax.ajax({
            url: Config.getBasePath() + '/entsq/sq_HisList',
            params: {},
            callback: (data) => {
                if (data && data.status === 0) {
                    data.results.forEach(da => {
                        if (da.HJMC !== '撤回') {
                            da.HJMC = da.SFTJ === 'N' ? '草稿' : da.HJMC
                        }
                        // if(da.SFTJ === 'N'){
                        //     da.HJMCNODE = <div className="sg-table-color sg-table-color2" style={{fontWeight:400}}>{da.HJMC}</div>
                        // }else if(da.HJMC.indexOf('驳回') !== -1){
                        //     da.HJMCNODE = <div className="sg-table-color sg-table-color1" style={{fontWeight:400}}>{da.HJMC}</div>
                        // }else if(da.HJMC.indexOf('草稿') !== -1){
                        //     da.HJMCNODE = <div className="sg-table-color sg-table-color2" style={{fontWeight:400}}>{da.HJMC}</div>
                        // }else if(da.HJMC.indexOf('退回') !== -1){
                        //     da.HJMCNODE = <div className="sg-table-color sg-table-color3" style={{fontWeight:400}}>{da.HJMC}</div>
                        // }else if(da.HJMC.indexOf('审核中') !== -1){
                        //     da.HJMCNODE = <div className="sg-table-color sg-table-color4" style={{fontWeight:400}}>{da.HJMC}</div>
                        // }else if(da.HJMC.indexOf('撤回') !== -1){
                        //     da.HJMCNODE = <div className="sg-table-color sg-table-color2" style={{fontWeight:400}}>{da.HJMC}</div>
                        // }else{
                        //     da.HJMCNODE = <div className="sg-table-color sg-table-color5" style={{fontWeight:400}}>{da.HJMC}</div>
                        // }


                        // {record.HJMC==='县审核'?'待审核':''}
                        // {record.HJMC==='县报送'?'[县级]审核通过':''}
                        // {record.HJMC==='市报送'?'[市级]待审核':''}
                        // {record.HJMC==='市报送退回'?'[市级]退回':''}
                        // {record.HJMC==='市报送驳回'?'[市级]驳回':''}
                        // {record.HJMC==='省审核'?'[省级]待审核':''}
                        // {record.HJMC==='省报送驳回'?'[省级]驳回':''}
                        // {record.HJMC==='总局'?'认定入库':''}
                        // {!['总局','省报送驳回','省审核','市报送驳回','市报送退回','市报送','县报送','县审核'].includes(record.HJMC)?record.HJMC:''}
                    })
                    this.setState({
                        data: data.results,
                        total: data.total,
                    })
                }
            }
        }, this);
        if (localStorage.getItem('defaultValue')) {
            let defaultValue;
            let arr = localStorage.getItem('defaultValue').split(',')
            if (arr.length === 3) {
                defaultValue = arr[2]
            }
            // WidgetAjax.ajax({
            //     url: Config.getBasePath() + '/businessSystem/setting',
            //     params: {
            //         SSQXID: defaultValue
            //     },
            //     callback: (data) => {
            //         console.log(data)
            //         if (data && data.status === 0) {
            //             // if (data.result.STATE === '0') {
            //             //     this.setState({
            //             //         columns: [
            //             //             { name: 'TASKNAME', title: '申报任务', type: 'string', description: '申报任务', properties: { width: 220 } },
            //             //             { name: 'creating_time', title: '申报时间', type: 'string', description: '申报时间', },
            //             //             {
            //             //                 name: 'HJMCNODE', title: '申报状态', type: 'string', description: '申报状态', properties: {
            //             //                     render: (completed, record) => {
            //             //                         return (
            //             //                             <div className="sd-start">
            //             //                                 <span>

            //             //                                 </span>
            //             //                             </div>
            //             //                         );
            //             //                     },
            //             //                 }
            //             //             },

            //             //             {
            //             //                 name: "operation", title: "操作", type: "string", description: "操作", properties: {
            //             //                     operations: [
            //             //                         { name: "查看详情", click: "viewDetail" },
            //             //                         { name: "修改资料", click: "editInfo", render: { condition: 'HJMC', value: ['县审核退回', '市报送退回', '省审核退回', '市审核退回'] } },
            //             //                         { name: "撤销", click: "withdraw", render: { condition: 'HJMC', value: ['草稿', '待审核', '县审核退回', '市报送退回', '市审核退回'] } },
            //             //                         { name: "申报通知", click: "goNotice" },

            //             //                     ]
            //             //                 },
            //             //             },
            //             //         ],
            //             //     })
            //             // }


            //         }
            //     }
            // });
        }


    };
    notify(type, data, value, index, event, val) {
        if (type === 'viewDetail') {
            this.goInformation(data);
        }
        if (type === 'editInfo') {
            // if(data.HJMC === '草稿'){

            // }

            this.props.history.push({ pathname: "/home/filling", state: { SQID: data.SQID, SFTJ: data.SFTJ } });
        }

        if (type === 'withdraw') {
            this.setState({
                revokeInfo: data
            })
            this.modal.open();
        }
        if (type === 'goNotice') {
            this.props.history.push({ pathname: "/home/notice", state: { SQID: data.SQID } });
        }

    }
    onRef = (ref) => {
        this.modal = ref;
    };
    goInformation(data) {
        let gradeNum = 0
        if (data.HJMC === '待审核') {
            gradeNum = 0
        } else if (data.HJMC.indexOf('县') !== -1) {
            gradeNum = 0
        } else if (data.HJMC.indexOf('市') !== -1) {
            gradeNum = 1
        } else if (data.HJMC.indexOf('省') !== -1) {
            gradeNum = 2
        } else {
            gradeNum = 3
        }
        this.props.history.push({ pathname: "/home/information", state: { ND: data.ND, SQID: data.SQID, TASKNAME: data.TASKNAME, creating_time: data.creating_time, HJMC: data.HJMC, gradeNum: gradeNum, SFTJ: data.SFTJ } });
    }
    onChange(value) {
        console.log(value);
    };
    goPage() {
        window.history.go(-1);
    }
    onOk() {
        this.modal.onClose();
        WidgetAjax.ajax({
            url: Config.getBasePath() + '/entsq/revoke',
            params: {
                SQID: this.state.revokeInfo.SQID
            },
            callback: (data) => {
                if (data && data.status === 0) {
                    message.error({
                        content: '撤销成功！',
                        style: { marginTop: '30vh' }
                    });
                    this.querySqHisList()
                } else {
                    message.error({
                        content: data.message,
                        style: { marginTop: '30vh' }
                    });
                }
            }
        }, this);
    }
    render() {
        const { columns, tableOptions, total, data, modelOptions, isHide } = this.state;
        return (
            <div data-component="guide">
                <div className="sg-guide-all">
                    <div className="sg-login-top sd-start">
                        <div onClick={() => { this.goPage() }} className="sd-start">
                            <img className='sg-information-img' alt='#' src={require('../../img/business/upPage.png')} />
                            <span className="sg-top-font" style={{ color: '#357AC5' }}>返回</span>
                        </div>

                    </div>
                    <div className="sg-notice">
                        <div className="sg-notice-center">
                            <div className="sg-center-top sd-start">
                                <span className="sg-center-font">申报历史</span>
                            </div>
                            <div className="sg-center-middle sd-columnCenter">
                                <div className="sg-middle-list">
                                    <WidgetTable columns={columns} options={tableOptions} data={data} total={total} notify={(e, i) => { this.notify(e, i) }} pageTurning={this.pageTurning} check={false} isFooter={true} />
                                </div>
                            </div>
                        </div>
                    </div>
                    <WidgetModal options={modelOptions} onRef={this.onRef} isHide={isHide} onOk={this.onOk}></WidgetModal>
                </div>
            </div>
        )
    }
}

export default Index
